import Cookies from 'js-cookie';
import { WISHLIST_DATA_COOKIE_KEY, WISHLIST_GUEST_USER_COOKIE_KEY } from '../constants';

export const getWishlistItem = (wishlistSkus: string[], sku: string) => {
  const wishedItem = wishlistSkus.find((item) => item === sku);

  return {
    wishedItem,
    isWished: Boolean(wishedItem),
  };
};

export const getWishListCustomerKeyCookie = () => {
  const wishlistGuestKey = Cookies.get(WISHLIST_GUEST_USER_COOKIE_KEY);
  return { wishlistGuestKey };
};

const BASE36_RADIX = 36;
const RANDOM_SUFFIX_START = 2;
const RANDOM_SUFFIX_END = 12;

/**
 * Mints the key a guest wishlist is stored under.
 *
 * The client owns this key so that concurrent first adds share one wishlist. Letting the API issue
 * it per request means two hearts clicked before the first response lands create two wishlists,
 * and whichever response writes storage last strands the other SKU under an unreferenced key.
 */
export const createGuestCustomerKey = (): string => {
  const randomUUID = globalThis.crypto?.randomUUID;
  if (typeof randomUUID === 'function') {
    return randomUUID.call(globalThis.crypto);
  }
  return `guest_${Date.now().toString(BASE36_RADIX)}_${Math.random().toString(BASE36_RADIX).slice(RANDOM_SUFFIX_START, RANDOM_SUFFIX_END)}`;
};

/**
 * Only for sync data with wordpress, not for NextJS
 * @param wishlistSkus
 */
export const setWishlistSku = (wishlistSkus: string[]) => {
  if (wishlistSkus.length === 0) {
    Cookies.remove(WISHLIST_DATA_COOKIE_KEY);
    return;
  }
  const joinedWishlistSkus = wishlistSkus.join('|');
  Cookies.set(WISHLIST_DATA_COOKIE_KEY, joinedWishlistSkus);
};
